<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold"
          v-text="'Share with Membership Groups'"
        />
      </header>
      <div>
        <div class="flex justify-center items-baseline mt-4">
          <div class="input-group">
            <input
              v-model="search"
              type="text"
              placeholder="Search"
            >
          </div>
          <div class="text-xs pl-4">
            <a
              href="#"
              @click.prevent="selectAllGroups"
              v-text="'Select All'"
            />
            |
            <a
              href="#"
              @click.prevent="selectNoGroups"
              v-text="'Select None'"
            />
          </div>
        </div>
        <ul class="scroll-checklist scroll-blue">
          <template v-if="filteredMembershipGroups.length && !isLoading">
            <li
              v-for="membershipGroup in filteredMembershipGroups"
              :key="membershipGroup.uuid"
            >
              <input
                :id="`group-${membershipGroup.uuid}`"
                v-model="selectedGroups"
                type="checkbox"
                :name="`group-${membershipGroup.uuid}`"
                :value="membershipGroup.uuid"
              >
              <label
                :for="`group-${membershipGroup.uuid}`"
                class="checkbox"
                v-text="membershipGroup.attributes.title"
              />
            </li>
          </template>
          <li v-if="!filteredMembershipGroups.length && !isLoading">
            <div
              class="text-sm text-center italic mb-4"
              v-text="'No results'"
            />
          </li>
        </ul>
        <div class="modal-footer text-center mt-4">
          <a
            href="#"
            class="btn"
            @click.prevent="sendToExistingGroups"
            v-html="sendToExistingGroupsText"
          />
          <a
            href="#"
            class="ml-4"
            @click.prevent="cancel"
            v-text="'Cancel'"
          />
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'SendCommToGroupsModal',
  props: {
    preSelectedGroups: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      search: '',
      selectedGroups: [],
    }
  },
  computed: {
    membershipGroups() {
      return this.$store.getters.membershipGroups
    },
    show() {
      return this.$store.state.communication.sendToGroupsModal.open
    },
    sendToExistingGroupsText() {
      return this.selectedGroups.length === 1
        ? 'Select 1 group'
        : `Select ${this.selectedGroups.length} groups`
    },
    filteredMembershipGroups() {
      if (this.membershipGroups.length) {
        return this.membershipGroups.filter((group) => {
          return group.attributes.title.toLowerCase().includes(this.search.toLowerCase())
        })
      }

      return []
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (!this.membershipGroups.length) {
          this.$store.dispatch('membershipGetMembershipGroups')
        }
      }
    },
    preSelectedGroups() {
      const vm = this

      this.preSelectedGroups.map(function (group){
        vm.selectedGroups.push(group)
      })
    },
  },
  methods: {
    sendToExistingGroups() {
      this.$emit('send', this.selectedGroups)

      this.close()
    },
    selectAllGroups() {
      this.selectedGroups = this.membershipGroups.map(group => group.uuid)
    },
    selectNoGroups() {
      this.selectedGroups = []
    },
    close() {
      this.$store.commit('communicationCloseSendToGroupsModal')

      const vm = this

      setTimeout(function () {
        vm.search = ''
      }, 2000)
    },
    cancel() {
      this.close()
    },
  },
}
</script>
